var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"c-webmention-list"},_vm._l((_vm.filteredWebmentions),function(ref){
    var author = ref.author;
    var content = ref.content;
    var published = ref.published;
    var url = ref.url;
    var id = ref['wm-id'];
return _c('li',{key:id,staticClass:"c-webmention-list__item"},[_c('webmention-entry',_vm._b({},'webmention-entry',{ id: id, author: author, content: content, published: published, url: url },false))],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }